import { awaitRequests, promise } from '../../../helpers';
import { firebaseUpdate } from '../firebase';
import { getExamSubmissions, saveExamSubmissionFiles } from './index';
import { upsertGradeForSubmission } from '../grades';

const updateExamSubmission = ({ docId, where, data, uploadList }) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        // -- update
        const update = (d, id) => dispatch(firebaseUpdate({ collection: 'examSubmissions', docId: id, data: d }));

        // -- after update
        const afterUpdate = item => {
            const reqs = [];

            // upload files
            reqs.push(dispatch(saveExamSubmissionFiles(item, uploadList)));
            reqs.push(dispatch(upsertGradeForSubmission(item, 'exam')));

            return awaitRequests(reqs).then(() => promise(item));
        };

        // -- single update
        if (docId && data) {
            return update(data, docId).then(updatedItem => afterUpdate(updatedItem));
        }

        // -- multiple update
        if (where && data) {
            return dispatch(getExamSubmissions({ where })).then(items => {
                return awaitRequests(items.map(item => update(data, item.id).then(updatedItem => afterUpdate(updatedItem))));
            });
        }

        return promise();
    };
};

export default updateExamSubmission;
